import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TemplatePortal } from '@angular/cdk/portal';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActionBarPortalService } from '@core/services/common/action-bar-portal.service';

export interface AppShellMenuItem {
  label: string;
  route?: string;
  iconName?: string;
}

@Component({
  selector: 'arkik-core-shell-layout',
  templateUrl: './app-shell-layout.component.html',
  styleUrls: ['./app-shell-layout.component.scss'],
})
export class AppShellLayoutComponent implements OnInit, OnDestroy {
  @Input() appName = 'Application';
  @Input() logo = '';
  @Input() userName = 'User';
  @Input() menuItems: AppShellMenuItem[] = [];

  openMenu = true;
  actionBarPortal: TemplatePortal | null = null;
  forceActionBarLayout = false;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private actionBarPortalService: ActionBarPortalService,
  ) {}

  ngOnInit(): void {
    this.actionBarPortalService.portal$.pipe(takeUntil(this.destroy$)).subscribe((portal) => {
      this.actionBarPortal = portal;
    });

    this.actionBarPortalService.forceLayoutClass$.pipe(takeUntil(this.destroy$)).subscribe((forceLayoutClass) => {
      this.forceActionBarLayout = forceLayoutClass;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSidenavToggle(): void {
    this.openMenu = !this.openMenu;
  }

  onMenuCollapsed(event: Event): void {
    const collapsed = !!(event as CustomEvent<boolean>).detail;
    this.openMenu = !collapsed;
  }

  navigate(item: AppShellMenuItem): void {
    if (item.route) {
      void this.router.navigate([item.route]);
    }
  }
}
